// extracted by mini-css-extract-plugin
export default {"selectionActionButton":"ManagerMemberList_selectionActionButton__XStcA"};